<script lang="ts" module>
  import type { ActionComponentProps } from '@agapi/ui/utils';

  export interface CollectionCardProps extends ActionComponentProps {
    title: string;
    imageUrl: string;
    href: string;
  }
</script>

<script lang="ts">
  import { Card, CardImage, CardOverlay, CardContent } from '@agapi/ui/card';
  import { useActions } from '@agapi/ui/utils';
  import { css } from '@agapi/ui/panda/css';

  import { cardStyles } from '../collection-grid.styles';

  const { use, title, imageUrl, href }: CollectionCardProps = $props();

  const classes = cardStyles.raw();
</script>

<a href={href} use:useActions={use ?? []}>
  <Card imageBg css={classes.root} colorVariant="primary.subdued">
    <CardImage
      src={imageUrl}
      alt=""
      width={8}
      background={imageUrl + '?width=8'}
      css={classes.image}
      />
    <CardOverlay css={classes.overlay}>
      <CardContent>
        <h3 class={css(classes.title)}>{title}</h3>
      </CardContent>
    </CardOverlay>
  </Card>
</a>
